import React from "react"
import { Field, FieldProps } from "formik"

import OptionsGroup from "@components/prototypes/FilterSidebar/components/OptionGroup/OptionGroup"
import UserSelect from "@components/prototypes/FilterSidebar/components/UserSelect/UserSelect"
import { assignStatusOptions } from "@framework/constants/analytics"
import RatingSelect from "@components/prototypes/FilterSidebar/components/RatingSelect/RatingSelect"
import QueryTypeSelect from "@components/prototypes/FilterSidebar/components/QueryTypeSelect/QueryTypeSelect"

const FilterFormBody: React.FC = () => (
  <>
    <Field name="queryTypes" label="Query Type" component={QueryTypeSelect} />

    <Field
      name="userIds"
      label="By User"
      valueKey="id"
      component={UserSelect}
      showSuperAdmins={false}
    />

    <Field name="ratings" label="Rating" component={RatingSelect} />

    <Field name="assignStatus">
      {({ field, form }: FieldProps) => (
        <OptionsGroup
          label="Assign Status"
          options={assignStatusOptions}
          value={field.value}
          onChange={(value) => form.setFieldValue(field.name, value)}
        />
      )}
    </Field>
  </>
)

export default FilterFormBody
